import { page } from './templates';

export default {
	pages: [],
	page: {...page}
};
